import { FormControlLabel, Switch } from '@mui/material';
import { Controller, Control, FieldError, FieldValues, Path } from 'react-hook-form';

interface ToggleFormInputProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  error?: FieldError;
}

export default function ToggleFormInput<T extends FieldValues>({
  control,
  name,
  label,
  error
}: ToggleFormInputProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={false as any}
      render={({ field: { onChange, value, ref } }) => (
        <>
          <FormControlLabel control={<Switch checked={value} onChange={onChange} ref={ref} />} label={label || ''} />
          {error && <p style={{ color: 'red', fontSize: '0.8rem' }}>{error.message}</p>}
        </>
      )}
    />
  );
}
